import outputMsgEngine from '../../../Widgets/OutputMsgWidget/Core/OutputMsgEngine';
import { flattenClassShapes } from './CanvasShapeFlattener';

/**
 * Collects the names of every class/interface shape already on the canvas —
 * ANY depth of package nesting (package-in-package is supported by the canvas,
 * see UmlCompositeShape/PackageContainmentHandler), via the already-tested
 * flattenClassShapes helper (shared with AssociationConnectorBuilder/
 * InheritanceConnectorBuilder) rather than a local one-level-deep reimplementation
 * — the earlier shallow version missed classes nested 2+ package-levels deep,
 * letting a re-import slip a real duplicate shape onto the canvas.
 * @param {object[]} existingShapes
 * @returns {Set<string>}
 */
function collectExistingClassNames(existingShapes) {
    const names = new Set();
    flattenClassShapes(existingShapes).forEach(function collectName(shape) {
        if (shape.caption?.text) names.add(shape.caption.text);
    });
    return names;
}

/**
 * Filters out any parsed class/interface whose name already exists on the
 * canvas — posts a warning to OutputMsgDlg per skip instead of silently
 * dropping it. Import-time only; doesn't touch existing shapes/connectors.
 * @param {object[]} parsedClasses
 * @param {object[]} existingShapes - top-level shapes already on the canvas
 * @returns {object[]} parsedClasses with duplicates removed
 */
export function filterDuplicateClasses(parsedClasses, existingShapes) {
    const existingNames = collectExistingClassNames(existingShapes);
    return parsedClasses.filter(function skipDuplicates(parsed) {
        if (existingNames.has(parsed.name)) {
            outputMsgEngine.addMsg('UmlWorkspace', 'warning', `${parsed.name}: Shape with the same name already exists, skipping`);
            return false;
        }
        return true;
    });
}
